<template>
  <div class="box">
    <header class="header">
      <div>
        <span class="icon"
          ><i class="fa fa-train" style="font-size: 16px"></i
        ></span>
      </div>
    </header>
    <div class="body">
      <span class="value">{{ value }}</span>
    </div>
    <div class="main">
      <span class="text">{{ leftText }}</span>
      <span class="text-center">0</span>
      <span class="text">{{ rightText }}</span>
      <div class="separator"></div>
      <div class="bar">
        <div class="left-bar">
          <div style="width: 30%" class="child"></div>
        </div>
        <div class="right-bar">
          <div class="child"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "custom-grid-box",
  props: ["title", "value", "voltage", "leftText", "rightText"],
  data() {
    return {};
  },
  computed: {},
  components: {},
  methods: {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f9f9f9;
  border: 1px solid #f0f0f0;
  height: 220px;
  display: flex;
  padding: 0;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;
  color: #999999;
  padding: 20px;
  font-size: 13px;
}

.footer {
  text-align: right;
  color: #f7ab3e;
}

.body {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 15px 0;
}

.value {
  font-size: 42px;
}

.icon {
  margin-right: 3px;
}

.main {
  border-top: 1px solid #f1f1f1;
  display: flex;
  color: #999999;
  position: relative;
  justify-content: space-between;
}

.text-center {
  display: block;
  flex-grow: 1;
  border-top: 1px solid #f1f1f1;
  padding-top: 20px;
  position: absolute;
  width: 100%;
}

.text {
  padding: 20px;
  display: block;
}

.separator {
  position: absolute;
  width: 1px;
  height: 15px;
  background-color: #f1f1f1;
  left: 0;
  right: 0;
  margin: 0 auto;
}

.bar {
  height: 10px;
  width: 100%;
  position: absolute;
  display: flex;

  .left-bar {
    width: 50%;
    position: relative;

    .child {
      background: #72b84ce6;
      right: 0;
    }
  }

  .right-bar {
    width: 50%;
    position: relative;

    .child {
      background: #fa716f;
    }
  }

  .child {
    height: 10px;
    position: absolute;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/dashboard/components/customGridBox.vue